import {
  discoveryApiRef,
  errorApiRef,
  fetchApiRef,
  useApi,
} from '@backstage/core-plugin-api';
import { useAsync } from 'react-use';
import { UserInfo } from '../types';

export const useGetUserInfo = (email?: string, refreshKey?: number) => {
  const discoveryApi = useApi(discoveryApiRef);
  const { fetch } = useApi(fetchApiRef);
  const errorApi = useApi(errorApiRef);

  const fetchUserInfo = async (): Promise<UserInfo | null> => {
    if (!email) {
      return null;
    }

    const response = await fetch(
      `${await discoveryApi.getBaseUrl('user-profile-info')}/users/${encodeURIComponent(email)}`,
      {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        },
      },
    );

    if (!response.ok) {
      const fetchError = new Error(`Failed to fetch user details`);
      if (refreshKey !== undefined) {
        errorApi.post(fetchError);
      }
      throw fetchError;
    }

    return (await response.json()) as UserInfo;
  };

  const { loading, value, error } = useAsync(fetchUserInfo, [
    email,
    refreshKey,
  ]);

  return { loading, value, error };
};
